export const initialState = {
  openMenu: true,
};
